import React from 'react';
import { Typography } from '@mui/material';
import { Button, Dialog } from '../../../components/ui';

export default function UserDeleteDialog({
  open,
  user,
  onClose,
  onConfirm,
  isDeleting = false,
}) {
  const displayName =
    [user?.first_name, user?.last_name].filter(Boolean).join(' ') ||
    user?.username ||
    'this user';

  return (
    <Dialog
      open={open}
      onClose={onClose}
      title="Confirm Deletion"
      actions={
        <>
          <Button variant="secondary" onClick={onClose} disabled={isDeleting}>
            Cancel
          </Button>
          <Button variant="destructive" loading={isDeleting} onClick={onConfirm}>
            Delete
          </Button>
        </>
      }
    >
      <Typography>
        Are you sure you want to delete user <strong>{displayName}</strong>?
      </Typography>
    </Dialog>
  );
}
